import * as React from 'react'

interface AssignedIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AssignedIcon: React.FC<AssignedIconProps> = ({
  color = '#888',
  gradient,
  width = 24,
  height = 23,
  alt = 'Assigned Icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 23'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M3.574 5.441a4.825 4.825 0 1 0 9.65 0 4.825 4.825 0 0 0-9.65 0M8.4 9.016a3.575 3.575 0 1 1 0-7.15 3.575 3.575 0 0 1 0 7.15m14.407-1.949c.262.225.293.62.068.881l-4.707 5.492-2.567-3.423a.625.625 0 0 1 1-.75l1.632 2.176 3.693-4.308a.625.625 0 0 1 .881-.068M15.55 17.741v2.5a.75.75 0 0 1-.75.75H2a.75.75 0 0 1-.75-.75v-2.5c0-1.128.495-2.2 1.355-2.931a8.945 8.945 0 0 1 11.59 0 3.85 3.85 0 0 1 1.355 2.931m-15.55 0c0-1.495.656-2.915 1.795-3.883a10.195 10.195 0 0 1 13.21 0A5.1 5.1 0 0 1 16.8 17.74v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default AssignedIcon
